import React from 'react';
import { BUTTON_VARIANTS } from './constants';

/**
 * Button Component
 * 
 * Standardized button component for dialogs
 * 
 * @param {string} variant - Button style variant ('primary', 'secondary', 'danger')
 * @param {function} onClick - Click handler
 * @param {boolean} disabled - Whether button is disabled
 * @param {string} children - Button text
 * @param {string} type - Button type attribute
 */
const Button = ({
  variant = 'primary',
  onClick,
  disabled = false,
  children,
  type = 'button',
  ...props
}) => {
  const variantClass = BUTTON_VARIANTS[variant] || BUTTON_VARIANTS.primary;
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`px-6 py-2 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${variantClass}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;

